import "../css/connections.css";
import "../css/button.css";
import commoncss from "../css/common.module.css";
import modalcss from "../css/modal.module.css";
import "../css/common.css";
import buttoncss from "../css/button.module.css";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import ReactDOM from "react-dom";
import { motion } from "framer-motion";

import axios from "axios";
import Card from "../elements/Card";
import Table from "../elements/Table";
import StatusIndicator from "../elements/StatusIndicator";
import { Button } from "../elements/Button";
import Modal from "../elements/Modal";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import { ReactComponent as InitDotIcon } from "../assets/icons/initDot.svg";
import { ReactComponent as SuccessDotIcon } from "../assets/icons/successDot.svg";
import { ReactComponent as ErrorDotIcon } from "../assets/icons/errorDot.svg";
import { ReactComponent as DownloadIcon } from "../assets/icons/download.svg";
import { ReactComponent as DeleteIcon } from "../assets/icons/delete.svg";
import { ReactComponent as LeftIcon } from "../assets/icons/left_arrow.svg";
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";
import { ReactComponent as MenuDotIcon } from "../assets/icons/menu_dot.svg";
import { ReactComponent as CalenderIcon } from "../assets/icons/calender.svg";
import { ReactComponent as ClockIcon } from "../assets/icons/clock.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import { ReactComponent as GreendotIcon } from "../assets/icons/greendot.svg";
import { ReactComponent as OrangedotIcon } from "../assets/icons/orangedot.svg";
import { ReactComponent as ReddotIcon } from "../assets/icons/reddot.svg";
// import companies from "../data/companies.json";
import years from "../data/years.json";
import months from "../data/months.json";
import DefaultUser from "../assets/imgs/default_user.png";
import InputGroup from "./../elements/InputGroup";
import getPullLogStatus from "./../components/mis";
import { getProfile } from "../../services/api/apiHandler";
import PullDataModal from "../components/connections/PullDataModal";
import FilterDataModal from "../components/connections/FilterDataModal";
import ExportDataModal from "../components/connections/ExportDataModal";
import SuccessModal from "../components/connections/SuccessModal";
import { headers } from "../../Bookclosure/Services/ApiHandler";

export default function Connections() {
  const domain = window.appConfig.backend_domain;
  const dispatch = useDispatch();

  const workspaceid = "";
  const projectid = "";

  const { userData } = useSelector((state) => state.AuthReducer);

  const [companies, setCompanies] = useState([]);
  const [requestType, setRequestType] = useState("PULL");
  const [connections, setConnections] = useState([]);
  const [connectionInfo, setConnectionInfo] = useState(null);
  const [erpPullInfo, setErpPullInfo] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [displayModal, setDisplayModal] = useState(false);
  const [pullModal, setPullModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [exportModal, setExportModal] = useState(false);
  const [connectionLogModal, setConnectionLogModal] = useState(false);
  const [pushDetailsModal, setPushDetailsModal] = useState(false);
  const [deleteConnectionModal, setDeleteConnectionModal] = useState(false);
  const [syncFromERPModal, setSyncFromERPModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [deleteConnectionId, setDeleteConnectionId] = useState(null);
  const [syncConnectionId, setSyncConnectionId] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [userid, setUserId] = useState("67cabbffd75a143ca862b101");

  useEffect(() => {
    setUserId(userData._id);
    console.log("userData._id", userData._id);
  }, [userData]);
  // "Re-pull failed entires",
  const pull_links = ["View Links", "Sync from ERP", "View Logs", "Delete"];

  // "Re-push failed entries",
  const push_links = ["View Details", "Push to ERP", "View Logs", "Delete"];

  useEffect(() => {
    GetUserData();
    getCompanies();
  }, []);

  useEffect(() => {
    getERPRequests();
  }, [requestType]);

  const GetUserData = () => {
    if (Object.keys(userData).length === 0) {
      getProfile()
        .then((response) => {
          dispatch({
            type: "USER_MIDDLEWARE_DATA",
            payload: response.data?.user?.data ?? {},
          });
        })
        .catch((error) => {
          swal("Error", error || `User Data Not Found`, "error");
        });
    }
  };
  useEffect(() => {
    if (connectionInfo !== null) {
      // Scroll the selected card to the top
      console.log("scroll connectionInfo", connectionInfo);

      cardRefs.current[connectionInfo]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [connectionInfo]);
  const getCompanies = () => {
    axios
      .get(`${domain}/api/v1/company/get-allCompany`, { headers })
      .then((res) => {
        console.log("res", res.data);
        setCompanies(res.data.getAllCompanyData);
      })
      .catch((error) => {
        console.error("Error fetching companies:", error);
      });
  };
  useEffect(() => {
    getERPRequests();

    const interval = setInterval(() => {
      getERPRequests();
    }, 3000);

    return () => clearInterval(interval);
  }, [requestType]);
  const getERPRequests = () => {
    axios
      .get(`${domain}/api/v1/erp/get-erprequests?reqtype=${requestType}`, {
        headers,
      })
      .then((res) => {
        setConnections(res.data.erpRequests);
      })
      .catch((error) => {
        console.error("Error fetching ERP requests:", error);
      });
  };

  const handleOpen = (index, rect) => {
    setPosition({
      top: rect.bottom + 8,
      left: rect.left + rect.width / 2,
    });
    setOpenMenuIndex(index);
  };

  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     setOpenMenuIndex(null);
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  const showConnectionInfo = async (connectionId) => {
    const resp = await axios.get(
      domain + "/api/v1/erp/get-activitylog?reqid=" + connectionId,
      { headers }
    );
    setErpPullInfo(resp.data.erpRequests);
    setConnectionInfo(connectionId);
  };

  const th_data = [
    { header: "PARTICULARS", accessor: "particulars" },
    { header: "PULL DATE", accessor: "pull_date" },
    { header: "PULL TIME", accessor: "pull_time" },
    { header: "STATUS", accessor: "status" },
  ];

  const tr_data = (erpPullInfo || []).map((item, i) => ({
    particulars: item.particulars,
    pull_date: item.logDate,
    pull_time: item.logTime,
    status: <StatusIndicator status={getPullLogStatus(item.status)} />,
  }));

  const deleteConnection = (cid) => {
    setDeleteConnectionModal(false);
    const payload = { cid: cid, action: "delete" };
    axios
      .post(domain + "/api/v1/erp/edit-connection", payload, { headers })
      .then((resp) => {
        if (resp.data.statusCode === 0) {
          getERPRequests();
          setSuccessMessage("Connection Deleted Successfully");
          setDisplayModal(true);
          setSuccessModal(true);
        }
      })
      .catch((error) => {
        console.error("Error Deleting connection:", error);
      });
  };

  const syncConnection = (cid) => {
    setSyncFromERPModal(false);
    const payload = { cid: cid, action: "sync" };
    axios
      .post(domain + "/api/v1/erp/edit-connection", payload, { headers })
      .then((resp) => {
        if (resp.data.statusCode === 0) {
          getERPRequests();
          setSuccessMessage("Sync Initiated Successfully");
          setDisplayModal(true);
          setSuccessModal(true);
        }
      })
      .catch((error) => {
        console.error("Error connection sync:", error);
      });
  };

  const getConnectionLog = async (cid) => {
    axios
      .get(domain + "/api/v1/erp/get-connection-log?reqId=" + cid, { headers })
      .then((resp) => {
        console.log(resp, resp.statusCode);
        if (resp.data.statusCode === 0) {
        }
      })
      .catch((error) => {
        console.error("Error in fetching connection log:", error);
      });
  };

  const handleClose = () => {
    setDisplayModal(false);
  };

  const showCardInfo = (cardLink, cid = null) => {
    if (cardLink === "View Logs") {
      console.log("cid", cid);
      getConnectionLog(cid);
      // setConnectionLogModal(true);
      // setDisplayModal(true);
    }

    if (cardLink === "Sync from ERP") {
      setSyncFromERPModal(true);
      setDisplayModal(true);
      setSyncConnectionId(cid);
    }

    if (cardLink === "Push to ERP") {
      handleAddRequestData({ reqid: cid }, "PUSH");
    }

    if (cardLink === "View Details") {
      setPushDetailsModal(true);
      setDisplayModal(true);
    }

    if (cardLink === "View Links") {
      viewPullLinks();
    }

    if (cardLink === "View Entries") {
      viewPushEntries();
    }

    if (cardLink === "Delete") {
      setDeleteConnectionModal(true);
      setDisplayModal(true);
      setDeleteConnectionId(cid);
    }
  };

  const viewPushEntries = (connectionId) => {
    window.location.href = `/myfinv2/connections/push/view-entries?reqid=${connectionId}`;
  };

  const viewPullLinks = (pushId) => {
    window.location.href = "/myfinv2/connections/pull/view-links";
  };

  const truncateText = (text = "", maxLength = 10) =>
    text && text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  const cardRefs = useRef({});
  const handleAddRequestData = (data, reqType) => {
    data["workspaceid"] = workspaceid;
    data["projectid"] = projectid;
    data["userid"] = userid;
    data["reqtype"] = reqType;
    data["status"] = "P";

    const payload = data;

    axios
      .post(domain + "/api/v1/erp/add-erp-request", payload, { headers })
      .then((resp) => {
        console.log(resp, resp.statusCode);
        if (resp.data.statusCode === 0) {
          getERPRequests();
          setSuccessMessage(
            `Intiated ${reqType === "PULL" ? "Pull" : ""} ${
              reqType === "PUSH" ? "Push" : ""
            } Request`
          );
          setDisplayModal(true);
          setSuccessModal(true);
        }
      })
      .catch((error) => {
        console.error(
          `Error ${reqType === "PULL" ? "Pull" : ""} ${
            reqType === "PUSH" ? "Push" : ""
          } request:`,
          error
        );
      });
  };
  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 0, opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      className="connections-wrapper"
    >
      <header className="connections-header">
        <span className="header-title">
          {connectionInfo !== null && (
            <>
              <LeftIcon
                className="clickable"
                onClick={() => {
                  setConnectionInfo(null);
                }}
                height={15}
              />
              &ensp;
            </>
          )}
          Connections
        </span>
        <div className="button-group">
          <button
            className={`${buttoncss.custom_btn} ${
              requestType === "PULL" ? buttoncss.primary : buttoncss.secondary
            }`}
            style={{ "border-radius": "8.18px 0px 0px 8.18px" }}
            onClick={() => {
              setRequestType("PULL");
            }}
          >
            Pull
          </button>
          <button
            className={`${buttoncss.custom_btn} ${
              requestType === "PUSH" ? buttoncss.primary : buttoncss.secondary
            }`}
            style={{
              "border-radius": "0 8.18px 8.18px 0",
            }}
            onClick={() => {
              setRequestType("PUSH");
            }}
          >
            Push
          </button>
        </div>
        <div className="header-actions">
          <FilterIcon
            className="clickable-icon"
            onClick={() => {
              setFilterModal(true);
              setDisplayModal(true);
            }}
            height={20}
          />

          <Button
            btnColor={buttoncss.secondary}
            label="Export"
            icon={<DownloadIcon />}
            onClick={() => {
              setExportModal(true);
              setDisplayModal(true);
            }}
          />

          {requestType === "PULL" ? (
            <Button
              label="Pull Data"
              btnColor={buttoncss.primary}
              onClick={() => {
                setPullModal(true);
                setDisplayModal(true);
              }}
              icon={<PlusIcon />}
            />
          ) : requestType === "PUSH" ? (
            // <Button btnColor={"primary"} label="Push to ERP" />
            ""
          ) : (
            ""
          )}
        </div>
      </header>
      <div className={`flex-container ${commoncss.scrollableArea}`}>
        {requestType === "PULL" && (
          <div
            className={`${
              connectionInfo != null
                ? "single-row-cards-content"
                : "connections-content"
            }`}
          >
            <main>
              <div
                className={`${
                  connectionInfo != null ? "tableCardGrid" : "card-grid"
                }`}
              >
                {connections.map((connection, i) => {
                  const colIndex = i % 5; // 0-based column i in 5-column layout

                  // Define variation sets
                  const leftToRightVariants = [
                    { x: -120, y: -10, duration: 0.4 },
                    { x: -100, y: 5, duration: 0.6 },
                    { x: -150, y: 15, duration: 0.5 },
                  ];

                  const rightToLeftVariants = [
                    { x: 120, y: -10, duration: 0.4 },
                    { x: 100, y: 10, duration: 0.6 },
                    { x: 140, y: 20, duration: 0.5 },
                  ];

                  const middleColumnVariants = [
                    { x: -80, y: 0, duration: 0.5 },
                    { x: 80, y: 0, duration: 0.5 },
                    { x: 0, y: -100, duration: 0.6 },
                    { x: 0, y: 100, duration: 0.4 },
                    { x: -100, y: -100, duration: 0.7 },
                  ];

                  // Pick variant based on column
                  let variant;
                  if (colIndex <= 1) {
                    variant =
                      leftToRightVariants[i % leftToRightVariants.length];
                  } else if (colIndex >= 3) {
                    variant =
                      rightToLeftVariants[i % rightToLeftVariants.length];
                  } else {
                    variant =
                      middleColumnVariants[i % middleColumnVariants.length];
                  }
                  return (
                    <motion.div
                      initial={{ x: variant.x, y: variant.y, opacity: 0 }}
                      animate={{ x: 0, y: 0, opacity: 1 }}
                      transition={{
                        duration: variant.duration,
                        ease: "easeOut",
                      }}
                      key={i}
                      style={{ position: "relative" }}
                      onMouseLeave={() => setOpenMenuIndex(null)}
                      onClick={() => {
                        showConnectionInfo(connection._id);
                      }}
                      ref={(el) => (cardRefs.current[connection._id] = el)}
                      className={`${connectionInfo != null ? "w20rem" : ""}`}
                      id={`card_${connection._id}`}
                    >
                      <Card
                        dimmed={
                          connectionInfo !== null
                            ? connectionInfo !== connection._id
                              ? "Y"
                              : "N"
                            : ""
                        }
                        clickable={true}
                        width="webkit-avaialable"
                        height="fit-content"
                        title={truncateText(connection.companyname, 14)}
                        actions={
                          <>
                            {/* <StatusIndicator status="Success" /> */}
                            <div
                              className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                const rect =
                                  e.currentTarget.getBoundingClientRect();
                                handleOpen(i, rect);
                              }}
                            >
                              <MenuDotIcon width={15} />
                            </div>
                          </>
                        }
                      >
                        <span className="card-info">
                          <CalenderIcon
                            width={18}
                            height={18}
                            className="vaMiddle"
                          />{" "}
                          &nbsp;{connection.transdatefrom} &nbsp;To&ensp;
                          <CalenderIcon
                            width={18}
                            height={18}
                            className="vaMiddle"
                          />{" "}
                          &nbsp;{connection.transdateto}
                        </span>
                        <br />
                        <span className="card-info">
                          <ClockIcon width={18} height={18} /> &nbsp;
                          {connection.reqdatetime}
                        </span>
                        <br />
                        {/* {i % 3 !== 0 ? ( */}
                        <span className={`card-info ${commoncss.w100}`}>
                          {" "}
                          <img
                            className="card-user-img"
                            src={DefaultUser}
                            alt="user_image"
                          />{" "}
                          &nbsp;
                          <span className="mt3">{connection.username}</span>
                          <span className="status-span">
                            <GreendotIcon />
                            &nbsp;{connection.activityLogCount}&ensp;
                            <OrangedotIcon />
                            &nbsp;{16 - connection.activityLogCount}&ensp;
                            <ReddotIcon />
                            &nbsp;0&ensp;
                          </span>
                        </span>
                        {/*  ) : (
                         <span className="card-info">
                           {" "}
                           <img
                             className="card-user-img"
                             src={User2}
                             alt="user_image"
                           />{" "}
                           &nbsp;<span className="mt3">Swizz Shannon</span>
                         </span>
                       )} */}
                        <br />
                      </Card>
                      {openMenuIndex === i &&
                        ReactDOM.createPortal(
                          <div
                            className="menu-box-global"
                            style={{
                              position: "absolute",
                              top: `${position.top}px`,
                              left: `${position.left}px`,
                              transform: "translateX(-50%)",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {pull_links.map((item, j) => (
                              <div
                                key={j}
                                className="menu-item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  showCardInfo(item, connection._id);
                                  setOpenMenuIndex(null);
                                }}
                              >
                                {item}
                              </div>
                            ))}
                          </div>,
                          document.body
                        )}
                    </motion.div>
                  );
                })}
              </div>
            </main>
          </div>
        )}

        {requestType === "PUSH" && (
          <div className="connections-content">
            <main>
              <div className="card-grid">
                {connections.map((connection, i) => {
                  const colIndex = i % 5; // 0-based column i in 5-column layout

                  // Define variation sets
                  const leftToRightVariants = [
                    { x: -120, y: -10, duration: 0.4 },
                    { x: -100, y: 5, duration: 0.6 },
                    { x: -150, y: 15, duration: 0.5 },
                  ];

                  const rightToLeftVariants = [
                    { x: 120, y: -10, duration: 0.4 },
                    { x: 100, y: 10, duration: 0.6 },
                    { x: 140, y: 20, duration: 0.5 },
                  ];

                  const middleColumnVariants = [
                    { x: -80, y: 0, duration: 0.5 },
                    { x: 80, y: 0, duration: 0.5 },
                    { x: 0, y: -100, duration: 0.6 },
                    { x: 0, y: 100, duration: 0.4 },
                    { x: -100, y: -100, duration: 0.7 },
                  ];

                  // Pick variant based on column
                  let variant;
                  if (colIndex <= 1) {
                    variant =
                      leftToRightVariants[i % leftToRightVariants.length];
                  } else if (colIndex >= 3) {
                    variant =
                      rightToLeftVariants[i % rightToLeftVariants.length];
                  } else {
                    variant =
                      middleColumnVariants[i % middleColumnVariants.length];
                  }
                  return (
                    <motion.div
                      initial={{ x: variant.x, y: variant.y, opacity: 0 }}
                      animate={{ x: 0, y: 0, opacity: 1 }}
                      transition={{
                        duration: variant.duration,
                        ease: "easeOut",
                      }}
                      key={i}
                      style={{ position: "relative" }}
                      onMouseLeave={() => setOpenMenuIndex(null)}
                    >
                      <Card
                        // clickable={true}
                        width="webkit-avaialable"
                        height="fit-content"
                        title={truncateText(connection.packagename, 14)}
                        actions={
                          <>
                            {/* {i % 3 === 0 ? (
                            <StatusIndicator status="In Progress" />
                          ) : i % 5 === 0 ? (
                            <StatusIndicator status="Failed" />
                          ) : (
                            <StatusIndicator status="Success" />
                          )} */}{" "}
                            <div
                              className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                const rect =
                                  e.currentTarget.getBoundingClientRect();
                                handleOpen(i, rect);
                              }}
                            >
                              <MenuDotIcon width={15} />
                            </div>
                          </>
                        }
                        onClick={() => {
                          viewPushEntries(connection._id);
                        }}
                      >
                        <span
                          onClick={() => {
                            viewPushEntries(connection._id);
                          }}
                        >
                          <span className="card-head1">
                            {truncateText(connection.companyname, 19)}
                          </span>
                          <br />
                          <span className="card-info">
                            <ClockIcon width={18} height={18} /> &nbsp;
                            {connection.reqdatetime}
                          </span>
                          <br />
                          <span className={`card-info ${commoncss.w100}`}>
                            {" "}
                            <img
                              className="card-user-img"
                              src={DefaultUser}
                              alt="user_image"
                            />{" "}
                            &nbsp;
                            <span className="mt3">{connection.username}</span>
                            {connection.entryStatusSummary && (
                              <span className="status-span">
                                <GreendotIcon />
                                &nbsp;{connection.entryStatusSummary.completed}
                                &ensp;
                                <OrangedotIcon />
                                &nbsp;{connection.entryStatusSummary.pending}
                                &ensp;
                                <ReddotIcon />
                                &nbsp;{connection.entryStatusSummary.failed}
                                &ensp;
                              </span>
                            )}
                          </span>
                          {/* {i % 3 !== 0 ? (
                          <span className="card-info">
                            {" "}
                            <img
                              className="card-user-img"
                              src={DefaultUser}
                              alt="user_image"
                            />{" "}
                            &nbsp;<span className="mt3">Adrienne Vossler</span>
                          </span>
                        ) : (
                          <span className="card-info">
                            {" "}
                            <img
                              className="card-user-img"
                              src={User2}
                              alt="user_image"
                            />{" "}
                            &nbsp;<span className="mt3">Swizz Shannon</span>
                          </span>
                        )} */}
                        </span>
                        <br />
                      </Card>
                      {openMenuIndex === i &&
                        ReactDOM.createPortal(
                          <div
                            className="menu-box-global"
                            style={{
                              position: "absolute",
                              top: `${position.top}px`,
                              left: `${position.left}px`,
                              transform: "translateX(-50%)",
                            }}
                          >
                            {push_links.map((item, j) => (
                              <div
                                key={j}
                                className="menu-item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  showCardInfo(item, connection._id);
                                  setOpenMenuIndex(null);
                                }}
                              >
                                {item}
                              </div>
                            ))}
                          </div>,
                          document.body
                        )}
                    </motion.div>
                  );
                })}
              </div>
            </main>
          </div>
        )}

        {requestType === "PULL" && connectionInfo != null && (
          <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="connections-content info-content"
          >
            <main>
              <Table columns={th_data} data={tr_data} />
              {/* <PaginationFooter /> */}
            </main>
          </motion.div>
        )}

        {pullModal && displayModal && (
          <PullDataModal
            companies={companies}
            handleClose={handleClose}
            setPullModal={setPullModal}
            displayModal={displayModal}
            pullModal={pullModal}
            setPullModalData={handleAddRequestData}
          />
        )}

        {filterModal && displayModal && (
          <FilterDataModal
            companies={companies}
            handleClose={handleClose}
            setFilterModal={setFilterModal}
          />
        )}

        {exportModal && displayModal && (
          <ExportDataModal
            years={years}
            months={months}
            handleClose={handleClose}
            setExportModal={setExportModal}
          />
        )}

        {connectionLogModal && displayModal && (
          <Modal
            title="View Log"
            headerActions={
              <CloseIcon
                onClick={() => {
                  handleClose();
                  setConnectionLogModal(false);
                }}
                className="clickable"
              />
            }
          >
            <span className="logItem">
              <span>
                <InitDotIcon /> &ensp;Adrienne Initiated a pull at 8:45 AM{" "}
              </span>
              <span className="primaryLableColor">4 Mar 2025</span>
            </span>
            <span className="logItem">
              <span>
                <SuccessDotIcon /> &ensp;Pull status successful at 9:00 AM{" "}
              </span>
              <span className="primaryLableColor">4 Mar 2025</span>
            </span>
            <span className="logItem">
              <span>
                <SuccessDotIcon /> &ensp;Synced successfully at 7:52 PM{" "}
              </span>
              <span className="primaryLableColor">13 Mar 2025</span>
            </span>
            <span className="logItem">
              <span>
                <ErrorDotIcon /> &ensp;Sync failed at 9:33 PM{" "}
              </span>
              <span className="primaryLableColor">13 Mar 2025</span>
            </span>
          </Modal>
        )}

        {pushDetailsModal && displayModal && (
          <Modal
            title="Package Name 123 - Details"
            headerActions={
              <CloseIcon
                onClick={() => {
                  handleClose();
                  setPushDetailsModal(false);
                }}
                className="clickable"
              />
            }
            footerActions={
              <>
                <Button
                  btnColor={buttoncss.secondary}
                  onClick={() => {
                    handleClose();
                    setPullModal(false);
                  }}
                  label="Cancel"
                />
                <Button btnColor={buttoncss.primary} label="Export" />
              </>
            }
            onClose={() => console.log("Modal Closed")}
          >
            <InputGroup
              label="Workspace Name"
              inputs={[
                <>
                  <input type="text" value={""} disabled />
                </>,
              ]}
            />

            <InputGroup
              label="Pushed From"
              inputs={[
                <>
                  <input type="text" value={""} disabled />
                </>,
              ]}
            />
          </Modal>
        )}

        {deleteConnectionModal && displayModal && (
          <Modal
            headerActions={
              <CloseIcon
                onClick={() => {
                  setDeleteConnectionId(null);
                  handleClose();
                  setDeleteConnectionModal(false);
                }}
                className="clickable"
              />
            }
            headerBottomLine={false}
            onClose={() => console.log("Modal Closed")}
          >
            <span className={`${modalcss.modalBodyHead} mb-1`}>
              Do you want to <span className="fw700">delete</span> the entry?
            </span>
            <span
              className={modalcss.modalBodycnt}
              style={{ "margin-bottom": "35px" }}
            >
              Once deleted, you cannot restore the entry
            </span>
            <span
              className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
            >
              <Button
                btnColor={buttoncss.danger}
                label="Delete"
                icon={<DeleteIcon width={20} height={20} />}
                onClick={() => {
                  deleteConnection(deleteConnectionId);
                }}
              />
              <Button
                btnColor={buttoncss.secondary_del}
                label="Cancel"
                onClick={() => {
                  setDeleteConnectionId(null);
                  handleClose();
                  setDeleteConnectionModal(false);
                }}
              />
            </span>
          </Modal>
        )}

        {syncFromERPModal && displayModal && (
          <Modal
            headerActions={
              <CloseIcon
                onClick={() => {
                  setSyncConnectionId(null);
                  handleClose();
                  setSuccessModal(false);
                  setSyncFromERPModal(false);
                }}
                className="clickable"
              />
            }
            headerBottomLine={false}
            onClose={() => console.log("Modal Closed")}
          >
            <span className={modalcss.modalBodyHead}>
              Are you sure you would like to sync?
            </span>
            <span className={modalcss.modalBodycnt}>
              All related workspaces and registers will be updated based on
              revised amounts
            </span>
            <span
              className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
            >
              <Button
                btnColor={buttoncss.primary}
                label="Yes, Sync"
                onClick={() => {
                  syncConnection(syncConnectionId);
                }}
              />
              <Button
                btnColor={buttoncss.secondary}
                label="No, Don't"
                onClick={() => {
                  setSyncConnectionId(null);
                  handleClose();
                  setSyncFromERPModal(false);
                  setSuccessModal(false);
                }}
              />
            </span>
          </Modal>
        )}

        {successModal && displayModal && (
          <SuccessModal
            handleClose={handleClose}
            setSuccessModal={setSuccessModal}
            setSuccessMessage={setSuccessMessage}
            successMessage={successMessage}
          />
          // <Modal
          //   headerActions={
          //     <CloseIcon
          //       onClick={() => {
          //         handleClose();
          //         setSuccessModal(false);
          //       }}
          //       className="clickable"
          //     />
          //   }
          //   onClose={() => console.log("Modal Closed")}
          // >
          //   <span className="modalBodyHead">
          //     <SuccessCheckIcon />
          //   </span>
          //   <span className="modalBodyHead">Sync Initiated Successfully</span>
          // </Modal>
        )}
      </div>
    </motion.div>
  );
}
